<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90%', maxWidth: '800px' }"
  styleClass="pro-feature-modal"
  (onHide)="onHide()"
>
  <div class="pro-feature-content">
    <h2 class="modal-title">This is a Pro feature</h2>
    <div class="divider"></div>
    <p class="modal-description">
      With Pro you'll be able to search, network, see your analytics, manage your leads, customize your PitchCard, etc....
    </p>
    <div class="pricing-section">
      <div class="plan-price">
        <span class="price-amount">
          <div class="price-container">
            <div class="price-main">
              <span class="price-dollars">$8</span>
              <span class="price-cents">.33</span>
            </div>
            <span class="price-suffix ml-3">Per Month <br> billed annually</span>
          </div>
        </span>
      </div>
    </div>
    <button
      pButton
      label="Upgrade to Pro"
      class="upgrade-button"
      (click)="upgradeToPro()"
    ></button>
    <div class="features-list">
      <div class="features-column">
        <div class="feature-item">
          <span class="checkmark">✓</span>
          <span>Everything in your current plan</span>
        </div>
        <div class="feature-item">
          <span class="checkmark">✓</span>
          <span>Unlimited Networking with other PitchCards</span>
        </div>
        <div class="feature-item">
          <span class="checkmark">✓</span>
          <span>Detailed Analytics</span>
        </div>
        <div class="feature-item">
          <span class="checkmark">✓</span>
          <span>Lead Manager & CRM Export</span>
        </div>
      </div>
      <div class="features-column">
        <div class="feature-item">
          <span class="checkmark">✓</span>
          <span>Instant Contact Exchange</span>
        </div>
        <div class="feature-item">
          <span class="checkmark">✓</span>
          <span>Business Card Scanner</span>
        </div>
        <div class="feature-item">
          <span class="checkmark">✓</span>
          <span>Customized PitchCard Branding</span>
        </div>
        <div class="feature-item">
          <span class="checkmark">✓</span>
          <span>Unlimited Networking Pockets</span>
        </div>
      </div>
    </div>
    <div class="flex justify-content-end align-items-center mt-4 w-full">
      <a class="maybe-later-link" (click)="maybeLater()">Maybe later</a>
    </div>
  </div>
</p-dialog>

